import React, { useCallback, useState } from "react";
import { Box, Stack, Tooltip } from "@mui/material";
import { globalTheme } from "../../styles";
import { useNavigate } from "react-router-dom";
import { leftNavItems } from "../../constants";
import { ReactElement, cloneElement } from "react";
import { ProfilePopover } from "../";
import { PrinterGuiDrawer } from "../PrinterGui";

interface HeaderType {
  isLeftNavExpanded: boolean;
}

export const Header = React.memo((props: HeaderType) => {
  const { isLeftNavExpanded } = props;
  const navigate = useNavigate();

  const hotMenuItems = React.useMemo(() => leftNavItems.filter((navItem) => !!navItem.hotKey), []);

  const handleHotMenuItemClick = useCallback(
    (redirectTo: string) => {
      navigate(redirectTo);
    },
    [navigate]
  );

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      paddingX={2}
      sx={{
        borderBottom: `1px solid ${globalTheme.border}`,
        height: "64px",
        color: globalTheme.primaryColor,
        width: isLeftNavExpanded ? "calc(100dvw - 270px)" : "100dvw",
        transition: "all .2s",
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{
          cursor: "pointer",
        }}
      >
        {hotMenuItems.map((hotMenu, key) => (
          <Tooltip title={hotMenu.title} key={`hotMenuItem-${key}`}>
            <Box
              paddingRight={1}
              sx={{
                height: "64px",
                display: "flex",
                alignItems: "center",
                borderRight: `1px solid ${globalTheme.border}`,
              }}
              onClick={() => handleHotMenuItemClick(hotMenu.redirectTo)}
            >
              {hotMenu.icon &&
                cloneElement(hotMenu.icon as ReactElement, {
                  fill: globalTheme.secondaryColor,
                })}
            </Box>
          </Tooltip>
        ))}
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{
          marginLeft: "auto",
          cursor: "pointer",
        }}
      >
        <Box
          paddingLeft={2}
          sx={{
            height: "64px",
            display: "flex",
            alignItems: "center",
            borderLeft: `1px solid ${globalTheme.border}`,
          }}
        >
          <PrinterGuiDrawer />
        </Box>
        <Box
          paddingLeft={2}
          sx={{
            height: "64px",
            display: "flex",
            alignItems: "center",
            borderLeft: `1px solid ${globalTheme.border}`,
          }}
        >
          <ProfilePopover />
        </Box>
      </Stack>
    </Stack>
  );
});
